import { render } from "./ItemLibrary.vue?vue&type=template&id=4ad1ceb2&scoped=true"
import script from "./ItemLibrary.vue?vue&type=script&lang=js"
export * from "./ItemLibrary.vue?vue&type=script&lang=js"

import "./ItemLibrary.vue?vue&type=style&index=0&id=4ad1ceb2&lang=less&scoped=true"

import exportComponent from "/Users/liuhaitao/ij_project/patent_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad1ceb2"]])

export default __exports__